<template lang="pug">
    v-card
        template(v-if="!isViewOnly")
            .d-flex.flex-no-wrap.justify-space-between
                .width-100-percent
                    v-card-actions.pa-4(style="display: flex; justify-content: space-between;")
                        template(v-if="scorecard.status === 'complete'")
                            StatusText(text="Reviewed")
                        template(v-else-if="scorecard.status === 'report_card'")
                            StatusText(:text="scorecard.status")
                        template(v-else)
                            v-btn.white--text.mr-5(
                                @click="completeScorecard()"
                                color="success"
                                width="125px"
                                :loading="isSaving"
                            )
                                v-icon mdi-check
                                | Reviewed

                            SwapTemplateDialog(
                                :key="scorecard.scorecard_template_id"
                                :handle-swap-scorecard-template="handleSwapScorecardTemplate"
                                :scorecard="scorecard"
                                :show-snackbar="showSnackbar"
                            )

                            DestroyDialog(
                                :handle-destroy-scorecard="handleDestroyScorecard"
                                :scorecard="scorecard"
                                :show-snackbar="showSnackbar"
                            )

                            template(v-if="renderSharedLinks")
                                SharedLinksDialog(
                                    :account-id="scorecard.account_id"
                                    component="scorecard_show"
                                    :has-large-button="true"
                                    :shareable-id="scorecard.scorecard_id"
                                    shareable-type="scorecard"
                                    :share-button-classes="'ml-5'"
                                )

                    div
                        v-btn.mr-2(
                            v-if="scorecard.status === 'complete'"
                            icon
                            large
                            @click="updateCompleteScorecardToInProgress"
                            style="text-decoration: none;"
                            color="disabled"
                            :loading="isUpdatingCompleteScorecardToInProgress"
                        ) 
                            v-icon(medium) mdi-circle-edit-outline


                        v-btn.mr-2(
                            v-if="$route.name === 'scorecards_index'"
                            icon
                            large
                            :to="{ name: 'scorecards_show', params: { vid: scorecardVid } }"
                            style="text-decoration: none;"
                        ) 
                            v-icon(medium) mdi-arrow-expand

                        v-btn(
                            icon
                            large
                            @click="onCloseCard()"
                            style="text-decoration: none;"
                        ) 
                            v-icon(large) mdi-close

                slot(name="completion-progress-bar")
                    v-progress-linear(v-model="completion")

        v-card#scorecard-container(flat :max-height="source === 'shared_link' ? '100%' : scorecardHeight" style="overflow-y: scroll;")
            v-card-text.pt-0.pb-2
                v-list.pb-0(subheader)
                    v-list-item.pl-0
                        //- v-list-item-avatar

                        v-list-item-content.py-5
                            v-list-item-title(style="font-weight: 500;")
                                div(:class="scorecardTitleClass")
                                    | {{ scorecardTitle }}

                            v-list-item-subtitle(style="white-space: normal;")
                                | {{ scorecardSubtitle }}
                        
   
                        v-tooltip(v-if="scorecard.status === 'complete'" top)
                            template(v-slot:activator="{ on, attrs }")
                                v-list-item-action.py-5.my-0.mt-2.mr-4(v-bind="attrs" v-on="on")
                                    v-switch(
                                        v-model="showPrivateNotes"
                                        color="primary"
                                        hide-details
                                        :key="showPrivateNotes"
                                        :disabled="isViewOnly"
                                    )
                                    v-list-item-subtitle 
                                        template(v-if="!showPrivateNotes") 
                                            | Agent View
                                        template(v-else)
                                            | Manager View

                            span(v-if="showPrivateNotes")
                                | Switch to Agent View | Hide Private Notes
                            span(v-else)
                                | Switch to Manager View | Show Private Notes
      
                        v-tooltip(v-if="userMatched" top)
                            template(v-slot:activator="{ on, attrs }")
                                v-list-item-action.py-5.my-0(v-bind="attrs" v-on="on")
                                    v-icon.pl-2.pr-2(large) mdi-face-agent
                            span {{ userMatchWarning }}

                        v-tooltip(v-if="customerMatched" top)
                            template(v-slot:activator="{ on, attrs }")
                                v-list-item-action.py-5.my-0(v-bind="attrs" v-on="on")
                                    v-icon.pl-2.pr-2(large) mdi-face-man-shimmer
                            span {{ customerMatchWarning }}
                        
                        v-tooltip(v-if="dispositionMatched" top)
                            template(v-slot:activator="{ on, attrs }")
                                v-list-item-action.py-5.my-0(v-bind="attrs" v-on="on")
                                    v-icon.pl-2.pr-2(large) mdi-text-search
                            span {{ dispositionMatchWarning }}

                        v-tooltip(v-if="customerEscalated" top)
                            template(v-slot:activator="{ on, attrs }")
                                v-list-item-action.py-5.my-0(v-bind="attrs" v-on="on")
                                    v-icon.pl-2.pr-2(large) mdi-fire-alert
                            span {{ customerEscalatedWarning }}

                        v-tooltip(v-if="appointmentOpportunityStatus" top)
                            template(v-slot:activator="{ on, attrs }")
                                v-list-item-action.py-5.my-0(v-bind="attrs" v-on="on")
                                    v-icon.pl-2.pr-2(large) mdi-hand-coin-outline
                            span {{ appointmentOpportunityStatusWarning(scorecard) }}

                            //- v-icon(v-if="showPrivateNotes" large) mdi-account-tie
                            //- v-icon(v-else large) mdi-face-agent
                        
                        //- v-list-item-action.py-5.my-0(v-if="validLlmAssessment")
                        //-     PulseColorIcon
                        
                        v-list-item-action.py-5.my-0.ml-2
                            v-progress-circular(
                                :value="scorePercentage"
                                :color="scoreColor" 
                                :rotate="-90"
                                :size="50"
                            )
                                template(v-if="scorecard.scorecard_template_id > 0")
                                    | {{ scorePercentage.toFixed(0) }}%
                                template(v-else)
                                    | {{ "N/A" }}
                                

            v-card-text.pt-0.pb-2(v-if="summaryLlmAssessmentItem" style="display: flex; flex-direction: row; flex-wrap: nowrap; justify-content: space-between; align-items: flex-start;")
                LlmAssessmentItem(
                    :llm-assessment-item="summaryLlmAssessmentItem"
                    :show-snackbar="showSnackbar"
                )

            v-card-text.pt-0(style="display: flex; flex-direction: row; flex-wrap: nowrap; justify-content: space-between; align-items: flex-start;")
                div(style="min-width: 49%; max-width: 49%; height: 100%;")

                    LlmAssessmentItems.mb-4(
                        :scorecard="scorecard"
                        :show-snackbar="showSnackbar"
                        @summaryLlmAssessmentItem="(x) => summaryLlmAssessmentItem = x"
                    )

                    ScorecardForm(
                        :key="scorecard.scorecard_template_id"
                        :close-card="onCloseCard"
                        :handle-update-scorecard="handleUpdateScorecard"
                        :handle-update-scorecard-completion="handleUpdateScorecardCompletion"
                        :is-view-only="isViewOnly"
                        :show-private-notes="showPrivateNotes"
                        :scorecard="scorecard"
                        :show-snackbar="showSnackbar"
                    )
                        template(v-slot:scorecard-items)
                            slot(name="scorecard-items")

                div(style="min-width: 2%; max-width: 2%; height: 100%;")
                div(style="min-width: 49%; max-width: 49%; height: 100%;")
                    slot(name="scorecard-criterion-card")
                        ScorecardCriterionCard.mb-4(
                            v-if="validScorecard"
                            readonly
                            title="Communication Details"
                            :campaign-names="[scorecard.campaign_name]"
                            :communication-type="scorecard.communication_type"
                            :disposition-descriptions="scorecardDispositionDescriptions"
                            :organization-names="[scorecard.organization_name]"
                            :notes="scorecardDispositionNotes"
                            :scorecard="scorecard"
                            :status="scorecard.status"
                            :user-display-names="[userDisplayName]"
                        )
                    ScorecardCommunicationDetails(
                        :hide-download-buttons="hideDownloadButtons"
                        :scorecard="scorecard"
                    )

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState from '@/store';

    // Components
    import DestroyDialog from '@/components/scorecards/destroy_dialog.vue';
    import LlmAssessmentItem from '@/components/scorecards/llm_assessment_item.vue';
    import LlmAssessmentItems from '@/components/scorecards/llm_assessment_items.vue';
    import PulseColorIcon from '@/components/scorecards/pulse_color_icon.vue';
    import ScorecardCommunicationDetails from "@/components/scorecards/communication_detail.vue";
    import ScorecardCriterionCard from '@/components/scorecard_criterions/card.vue';
    import ScorecardForm from "@/components/scorecards/form.vue";
    import SharedLinksDialog from '@/components/shared_links/dialog.vue';
    import StatusText from '@/components/shared/status_text.vue';
    import SwapTemplateDialog from '@/components/scorecards/swap_template_dialog.vue';

    // Data 
    import {
        CompleteScorecard,
        FindScorecard,
        UpdateCompleteScorecardToInProgress,
    } from '@/data';

    // Helpers
    import { getScorecardScorePercentage, scorecardScoreColor, } from "@/helpers/scorecard";
    import { titleize } from "@/helpers/general";

    export default Vue.extend({
        data() {
            return {
                completion: 1, // default to 1 better than 0 for ui indicator
                showPrivateNotes: true,
                isSaving: false,
                isUpdatingCompleteScorecardToInProgress: false,
                llmAssessmentItems: [],
                scorecardHeight: 1000,
                summaryLlmAssessmentItem: null,
            }
        },
        methods: {
            appointmentOpportunityStatusWarning(scorecard) {
                return "Opportunity status" + (scorecard?.llm_assessment?.appointment_opportunity_status  ? " : " + titleize(scorecard?.llm_assessment?.appointment_opportunity_status) : "") + " (determined via AI analysis)";
            },
            completeScorecard() {
                if (!this.validScorecard || this.scorecard.status === 'complete') {
                    return;
                }

                this.isSaving = true;
                CompleteScorecard(this.scorecard.scorecard_id).then((response) => {
                    if (response?.Data?.scorecard?.scorecard_id > 0) {
                        this.handleCompleteScorecard(response.Data.scorecard);
                    }

                    this.isSaving = false;
                });
            },
            findScorecard() {
                FindScorecard(this.scorecardId).then((response) => {
                    if (response?.Data?.scorecard?.scorecard_id > 0) {
                        this.setSharedLinkObject(response.Data.scorecard);
                    }
                });
            },
            formatEntityList(entities) {
                if (entities.length === 1) return entities[0];
                if (entities.length === 2) return `${entities[0]} and ${entities[1]}`;
                return `${entities.slice(0, -1).join(", ")}, and ${entities[entities.length - 1]}`;
            },
            handleWindowResize() {
                const scorecardTop = (document?.getElementById('#scorecard-container')?.getBoundingClientRect()?.top || 213);
                const windowInnerHeight = window?.innerHeight || 1080;
                this.scorecardHeight = windowInnerHeight - scorecardTop - 16;
            },
            init() {
                if (!(this.scorecard?.scorecard_id > 0)) {
                    this.findScorecard();
                }
            },
            updateCompleteScorecardToInProgress() {
                if (!this.validScorecard || this.scorecard.status !== 'complete') {
                    return;
                }

                this.isUpdatingCompleteScorecardToInProgress = true;
                UpdateCompleteScorecardToInProgress(this.scorecard.scorecard_id).then((response) => {
                    if (response?.Data?.scorecard?.scorecard_id > 0) {
                        this.handleUpdateCompleteScorecardToInProgress(response.Data.scorecard);
                    }

                    this.isUpdatingCompleteScorecardToInProgress = false;
                });
            },
            handleUpdateScorecardCompletion(completion) {
                if (completion > 0) {
                    this.completion = completion;
                }
            },
        },
        computed: {
            appointmentOpportunityStatus() {
                return this.scorecard?.llm_assessment?.appointment_opportunity_status;
            },
            customerEscalated() {
                return this.scorecard?.llm_assessment?.escalated_customer_id > 0;
            },
            customerEscalatedWarning() {
                return "Customer determined to be escalated via AI analysis"
            },
            customerMatched() {
                return this.scorecard?.llm_assessment?.customer_matched;
            },
            customerMatchWarning() {
                return "Customer may have been matched via AI entity detection"
            },
            currentUser() {
                return VolieState.currentUser();
            },
            dispositionMatched() {
                return this.scorecard?.llm_assessment?.disposition_matched;
            },
            dispositionMatchWarning() {
                return "Disposition may have been matched via AI entity detection"
            },
            entityDetectionMatchId() {
                return this.scorecard?.llm_assessment?.entity_detection_match_id > 0;
            },
            entityDetectionWarning() {
                const detectedEntities = [];

                const assessment = this.scorecard?.llm_assessment;
                if (assessment) {
                    if (assessment.customer_matched) {
                    detectedEntities.push("customer");
                    }
                    if (assessment.user_matched) {
                    detectedEntities.push("user");
                    }
                    if (assessment.disposition_matched) {
                    detectedEntities.push("disposition");
                    }
                }

                if (detectedEntities.length === 0) {
                    return "Redirect Call";
                }

                const entityStr = this.formatEntityList(detectedEntities);
                return `Redirect Call: ${entityStr} may have been matched via AI entity detection.`;
            },
            isViewOnly() {
                return this.source === 'shared_link';
            },
            scoreColor() {
                if (!this.scorecard) {
                    return 'grey';
                }
                if (this.scorecard.status === "pending") {
                    return 'grey';
                }

                return scorecardScoreColor(this.scorecard.points_scored, this.scorecard.points_available);
            },
            scorePercentage() {
                if (!(this.scorecard.points_available > 0)) {
                    return 0;
                }

                return getScorecardScorePercentage(this.scorecard.points_scored, this.scorecard.points_available);
            },
            scorecardDispositionDescriptions() {
                if (!(this.scorecard?.communication_dispositions?.length > 0)) {
                    return [];
                }

                return this.scorecard.communication_dispositions.map((x) => x.disposition_description);
            },
            scorecardDispositionNotes() {
                if (!(this.scorecard?.communication_dispositions?.length > 0)) {
                    return [];
                }

                const notes = [];
                this.scorecard.communication_dispositions.forEach((x) => {
                    if (x.communication_disposition_notes.length > 0) {
                        notes.push(x.communication_disposition_notes);
                    }

                })

                if (notes.length > 0) {
                    return notes.join(' | ');
                }

                return null;
            },
            scorecardSubtitle() {
                if (this.validLlmAssessment && this.scorecard?.name?.length > 0) {
                    return this.scorecard.name;
                }

                return null;
            },
            scorecardTitle() {
                if (this.validLlmAssessment) {

                    if (this.scorecard?.llm_assessment?.is_flagged) {
                        return "Flagged by Pulse";
                    }
                    if (!this.scorecard?.llm_assessment?.is_flagged) {
                        return "Approved by Pulse";
                    }

                    return "Pulse Assessment";
                }
                if (this.scorecard?.name?.length > 0) {
                    return this.scorecard.name;
                }

                return null;
            },
            scorecardTitleClass() {
                if (this.scorecardTitle === "Approved by Pulse") {
                    return "by-pulse-banner approved-by-pulse-banner";
                }
                if (this.scorecardTitle === "Flagged by Pulse") {
                    return "by-pulse-banner flagged-by-pulse-banner";
                }
                return "";
            },
            scorecardVid() {
                if (this.validScorecard) {
                    return this.scorecard.vid;
                }

                return null;
            },
            renderSharedLinks() {
                return this.currentUser?.account?.shared_links_enabled === true;
            },
            userDisplayName() {
                return this.scorecard.user_display_name || this.scorecard.llm_assessment.employee_first_name + ' ' + this.scorecard.llm_assessment.employee_last_name;
            },
            userMatched() {
                return this.scorecard?.llm_assessment?.user_matched || this.scorecard?.llm_assessment?.employee_id > 0;
            },
            userMatchWarning() {
                return "Employee may have been matched via AI entity detection"
            },
            validLlmAssessment() {
                return this.scorecard?.llm_assessment?.llm_assessment_id > 0 && this.scorecard.llm_assessment.valid_for_analytics === true && this.scorecard.llm_assessment.status === 'complete';
            },
            validScorecard() {
                return this.scorecard?.scorecard_id > 0;
            },
        },
        components: {
            DestroyDialog,
            LlmAssessmentItem,
            LlmAssessmentItems,
            PulseColorIcon,
            ScorecardCommunicationDetails,
            ScorecardCriterionCard,
            ScorecardForm,
            SharedLinksDialog,
            StatusText,
            SwapTemplateDialog,
        },
        props: {
            handleCompleteScorecard: Function,
            handleDestroyScorecard: Function,
            handleSwapScorecardTemplate: Function,
            handleUpdateCompleteScorecardToInProgress: Function,
            handleUpdateScorecard: Function,
            hideDownloadButtons: Boolean,
            onCloseCard: Function,
            scorecard: Object,
            scorecardId: Number,
            setSharedLinkObject: Function,
            showSnackbar: Function,
            source: String,
        },
        watch: {
            scorecard: {
                handler() {
                    Vue.nextTick(() => { this.handleWindowResize(); });
                },
                deep: true,
            },
        },
        created() {
            window.addEventListener('resize', this.handleWindowResize);

            this.init();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleWindowResize);
        },
        mounted() {
            setTimeout(() => {
                this.handleWindowResize();
            }, 10);
        },
    });
</script>

<style lang="scss" scoped>
</style>
